export default __webpack_public_path__ + "21b624f.png";